<template>
  <div class="welfare-box">
    <div class="bgImg">
      <img :src="$OSSBaseUrl+'WelfareH5Img_03.png'" alt="">
    </div>
    <div class="cover_body" v-if="videoShow"></div>
    <div class="video-box" v-if="videoShow">
      <img
        :src="$OSSBaseUrl+'x.png'"
        @click="videoShow=false"
        class="videoDialogClose"
      />
      <video
        style="width:100%;height:100%"
        id="DyVideo"
        preload="auto"
        autoplay="autoplay"
        loop="loop"
        src="https://wangxintong.oss-cn-zhangjiakou.aliyuncs.com/mobile_video/SVID_20201228_143443_1.mp4"
      >
        <source src type="video/mp4" />
      </video>
    </div>
    <div class="btn-box">
      <div class="buy-btn btn-item" @click="videoShow=true">
        <img :src="$OSSBaseUrl+'WelfareH5Img_01.png'" alt />
      </div>
      <div
        class="copy-btn btn-item"
        v-clipboard:copy="f"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
        <img :src="$OSSBaseUrl+'WelfareH5Img_02.png'" alt />
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Toast } from "vant";
export default {
  name: "WelfareH5",
  data() {
    return {
      f:"https://pc.1688.com/product/detail.htm?spm=a2619h.19708286.kipuuh9s.3.9fe87eb13mwkTX&&productCode=euJUu1uW%2B4kVKj%2B0PVJRQV5p1UvSbEFgS%2FQ2TPlJBd4%3D&productType=GROUP",
      videoShow: false
    };
  },
  methods: {
    // 复制成功时的回调函数
    onCopy(e) {
      Toast("链接复制成功，请打开浏览器粘贴购买");
    },
    // 复制失败时的回调函数
    onError(e) {
      Toast("链接复制失败，请稍后重试");
    }
  },
  mounted() {
    request({
      url: "https://wxt.xingyebao.com/h5/DryxRecord/inDryxRecord",
      method: "post",
    });
  }
};
</script>

<style scoped lang="scss">
@import "style.scss";
</style>